import {ssrSafeWindow} from '@github-ui/ssr-utils'

export const GITHUB_DESKTOP_DOWNLOAD_URL = 'https://desktop.github.com/'

/**
 * Build the GitHub Desktop URL for a pull request.
 * Uses the x-github-client protocol to open GitHub Desktop directly
 * Better solution might be pulling down the actual Desktop URL: /workspaces/github/app/helpers/desktop_helper.rb
 */
export function buildGitHubDesktopPullRequestUrl(repositoryNwo: string, pullNumber: number): string {
  const baseUrl = ssrSafeWindow?.location.origin || 'https://github.com'
  return `x-github-client://openRepo/${baseUrl}/${repositoryNwo}?pr=${pullNumber}`
}

/**
 * Build the GitHub Desktop URL for a branch. Returns undefined if window origin is not available.
 */
export function buildGitHubDesktopBranchUrl(repositoryNwo: string, branchName: string): string | undefined {
  const origin = ssrSafeWindow?.location.origin
  return origin ? `x-github-client://openRepo/${origin}/${repositoryNwo}?branch=${branchName}` : undefined
}
